import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=77948a2f&scoped=true&"
import script from "./Cadastro.vue?vue&type=script&lang=js&"
export * from "./Cadastro.vue?vue&type=script&lang=js&"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=77948a2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77948a2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77948a2f')) {
      api.createRecord('77948a2f', component.options)
    } else {
      api.reload('77948a2f', component.options)
    }
    module.hot.accept("./Cadastro.vue?vue&type=template&id=77948a2f&scoped=true&", function () {
      api.rerender('77948a2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/internalPages/Cadastro.vue"
export default component.exports